module.exports = __webpack_public_path__ + "static/media/map_pin_int_2.e9aa262c.svg";